module.exports = __webpack_public_path__ + "img/222934.21ea0b59.png";